import styled from 'vue3-styled-components';

// 모달 오버레이
export const ModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
`;

// 모달 컨테이너
export const ModalContainer = styled.div`
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
    width: 90%;
    max-width: 600px;
    max-height: 90vh;
    overflow: hidden;
`;

// 모달 헤더
export const ModalHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px 24px 16px 24px;
    border-bottom: 1px solid #e9ecef;
    background: linear-gradient(135deg, #0f4c5c 0%, #1a6b7a 100%);
    color: white;
`;

export const ModalTitle = styled.h2`
    font-size: 20px;
    font-weight: 600;
    color: #white;
    margin: 0;
    display: flex;
    align-items: center;
`;

export const CloseButton = styled.button`
    background: none;
    border: none;
    color: white;
    font-size: 20px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: all 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: scale(1.1);
    }
`;

// 모달 콘텐츠
export const ModalContent = styled.div`
    padding: 24px;
    max-height: 60vh;
    overflow-y: auto;

    /* 스크롤바 스타일링 */
    &::-webkit-scrollbar {
        width: 6px;
    }
    
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }
    
    &::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
        
        &:hover {
            background: #a8a8a8;
        }
    }
`;

// 폼 섹션
export const FormSection = styled.div`
    margin-bottom: 32px;

    &:last-child {
        margin-bottom: 0;
    }
`;

// 폼 선택
export const FormSelect = styled.select`
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #ffffff;
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
    }

    option {
        padding: 8px;
    }
`;

// API 헤더
export const ApiHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
`;

export const ApiName = styled.div`
    font-size: 16px;
    font-weight: 600;
    color: #212529;
`;

// API 상세 정보
export const ApiDetails = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ApiDetailItem = styled.div`
    display: flex;
    align-items: center;
    font-size: 12px;
`;

export const DetailLabel = styled.span`
    color: #6c757d;
    font-weight: 500;
    min-width: 60px;
`;

export const DetailValue = styled.span`
    color: #212529;
    font-weight: 400;
`;

export const SectionTitle = styled.h3`
    font-size: 16px;
    font-weight: 600;
    color: #495057;
    margin: 0 0 16px 0;
    padding-bottom: 8px;
    border-bottom: 2px solid #e9ecef;
`;

// 폼 그리드
export const FormGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
`;

export const FormGrid3 = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 768px) {
        grid-template-columns: 1fr;
    }
`;

// 폼 그룹
export const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
`;

export const FormLabel = styled.label`
    font-size: 14px;
    font-weight: 600;
    color: #495057;
    margin-bottom: 8px;
`;

export const FormInput = styled.input`
    padding: 12px 16px;
    border: 2px solid #e9ecef;
    border-radius: 8px;
    font-size: 14px;
    transition: all 0.3s ease;
    background: #ffffff;

    &:focus {
        outline: none;
        border-color: #0f4c5c;
        box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
    }

    &::placeholder {
        color: #adb5bd;
    }

    &.error {
        border-color: #dc3545;
        box-shadow: 0 0 0 3px rgba(220, 53, 69, 0.1);
    }
`;

// 에러 메시지
export const ErrorMessage = styled.div`
    color: #dc3545;
    font-size: 12px;
    margin-top: 4px;
    font-weight: 500;
`;

// API 목록 컨테이너
export const ApiListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;

// API 목록 아이템
export const ApiListItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 8px;
    transition: all 0.2s ease;

    &:hover {
        background: #e9ecef;
        border-color: #0d6efd;
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(13, 110, 253, 0.1);
    }
`;

export const ApiInfo = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
`;

export const ApiKey = styled.div`
    font-size: 14px;
    font-weight: 600;
    color: #212529;
`;

export const ApiActions = styled.div`
    display: flex;
    gap: 8px;
`;

export const EditButton = styled.button`
    background: linear-gradient(135deg, #ffc107 0%, #fd7e14 100%);
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(255, 193, 7, 0.3);
    }
`;

export const DeleteButton = styled.button`
    background: linear-gradient(135deg, #dc3545 0%, #c82333 100%);
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        transform: translateY(-1px);
        box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
    }
`;

export const RegisterAccountButton = styled.button`
    background-color: #10b981;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 4px;

    &:hover {
        background-color: #059669;
    }
`;

// 빈 상태
export const EmptyState = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    text-align: center;
    color: #6c757d;
`;

export const EmptyIcon = styled.div`
    font-size: 48px;
    margin-bottom: 16px;
    opacity: 0.5;
`;

export const EmptyText = styled.div`
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #495057;
`;

export const EmptySubText = styled.div`
    font-size: 14px;
    color: #6c757d;
`;

// 모달 푸터
export const ModalFooter = styled.div`
    padding: 16px 24px;
    border-top: 1px solid #e9ecef;
    background: #f8f9fa;
`;

export const FooterActions = styled.div`
    display: flex;
    gap: 12px;
    justify-content: flex-end;
`;

export const CancelButton = styled.button`
    background: #6c757d;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        background: #5a6268;
        transform: translateY(-1px);
    }
`;

export const SaveButton = styled.button`
    background: ${props => props.disabled
        ? '#6c757d'
        : '#0f4c5c'};
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
    transition: all 0.2s ease;

    &:hover {
        ${props => !props.disabled && `
            transform: translateY(-1px);
        `}
    }

    &:disabled {
        opacity: 0.6;
    }
`;

// 반응형 디자인
const responsiveStyles = `
    @media (max-width: 768px) {
        ${ModalContainer} {
            width: 95%;
            margin: 20px;
        }
        
        ${ModalHeader} {
            padding: 20px 20px 16px 20px;
        }
        
        ${ModalContent} {
            padding: 20px;
        }
        
        ${ModalFooter} {
            padding: 16px 20px;
        }
        
        ${FormGrid} {
            gap: 16px;
        }
        
        ${ApiListItem} {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
        
        ${ApiActions} {
            width: 100%;
            justify-content: flex-end;
        }
    }
    
    @media (max-width: 480px) {
        ${ModalContainer} {
            width: 98%;
            margin: 10px;
        }
        
        ${ModalHeader} {
            padding: 16px 16px 12px 16px;
        }
        
        ${ModalContent} {
            padding: 16px;
        }
        
        ${ModalFooter} {
            padding: 12px 16px;
        }
        
        ${FooterActions} {
            flex-direction: column;
        }
        
        ${CancelButton}, ${SaveButton} {
            width: 100%;
        }
    }
`;

export default {
    ...responsiveStyles
};